import { createSlice } from '@reduxjs/toolkit';

import config from 'config';

const initialState = {
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  outlinedFilled: config.outlinedFilled,
  navType: config.theme,
  presetColor: config.presetColor,
  locale: config.i18n,
  isSidebarOpen: true
};

export const customizationSlice = createSlice({
  name: 'customization',
  initialState,
  reducers: {
    setIsSidebarOpen(state, { payload: isSidebarOpen }) {
      state.isSidebarOpen = isSidebarOpen;
    }
  }
});

export const { setIsSidebarOpen } = customizationSlice.actions;

export default customizationSlice.reducer;
